export const decretoEnum = Object.freeze({
  decreto351: 'decreto351',
  decreto911: 'decreto911',
  decreto617: 'decreto617',
});

export const decretoToEnum = (decreto) => {
  switch (true) {
    case decreto.includes('351'):
      return decretoEnum.decreto351;
    case decreto.includes('911'):
      return decretoEnum.decreto911;
    case decreto.includes('617'):
      return decretoEnum.decreto617
    default:
      return '';
  }
}

export const tipoDeActividadPorDecreto = Object.freeze({
  [decretoEnum.decreto351]: "Industria",
  [decretoEnum.decreto911]: "Construcción",
  [decretoEnum.decreto617]: "Agraria",
})

export const preguntaHabilitantePlanillaAPorDecreto = Object.freeze({
  [decretoEnum.decreto351]: 159,
  [decretoEnum.decreto911]: 208,
  [decretoEnum.decreto617]: 149,
});

export const preguntaHabilitantePlanillaCPorDecreto = Object.freeze({
  [decretoEnum.decreto351]: 161,
  [decretoEnum.decreto911]: 210,
  [decretoEnum.decreto617]: 151,
});


export const preguntasDeshabilitadasPorDecreto = Object.freeze({
  [decretoEnum.decreto351]: [160],
  [decretoEnum.decreto617]: [150],
  [decretoEnum.decreto911]: [209],
})